import React from "react";
import AWSWebhookSuccessPopup from "./AWSWebhookSuccessPopup";

export default function GuardDutyWebhookSuccessPopup({webhookTokenUrl, toolName}){
    return <AWSWebhookSuccessPopup toolName={toolName} webhookTokenUrl={webhookTokenUrl}/>
}